import React from 'react'
import { Box, Button, Checkbox, FormControlLabel, IconButton, TextField } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

// Free-text questions asked from the customer when they enrol. Ids are deliberately
// not generated here: they are assigned at save by Firebase.resolveActivityExtraInfo,
// the same way event ticket extra info works.

function ExtraInfoQuestionsEditor({ value, onChange }) {
  const rows = Array.isArray(value) ? value : []

  const updateRow = (index, changes) =>
    onChange(rows.map((row, i) => (i === index ? { ...row, ...changes } : row)))

  const handleAdd = () => onChange([...rows, { title: '', required: false }])

  const handleRemove = (index) => onChange(rows.filter((_, i) => i !== index))

  return (
    <Box>
      {rows.map((row, index) => (
        // Index as key: rows have no id until they are saved.
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, flexWrap: 'wrap' }}>
          <TextField
            size='small'
            label='Kysymys'
            value={row.title || ''}
            onChange={(e) => updateRow(index, { title: e.target.value })}
            sx={{ minWidth: 320 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                color='success'
                checked={!!row.required}
                onChange={(e) => updateRow(index, { required: e.target.checked })}
              />
            }
            label='Pakollinen'
          />
          <IconButton aria-label='Poista kysymys' size='small' color='error' onClick={() => handleRemove(index)}>
            <DeleteIcon fontSize='small' />
          </IconButton>
        </Box>
      ))}
      <Button size='small' startIcon={<AddCircleOutlineIcon />} onClick={handleAdd}>
        Lisää kysymys
      </Button>
    </Box>
  )
}

export default ExtraInfoQuestionsEditor
